<section class="bg-white dark:bg-gray-900">
  <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
    <div class="mx-auto max-w-screen-sm text-center">
      <a
        routerLink="/"
        class="flex justify-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
      >
        <img class="w-1/4" src="./assets/img/logo_preto.png" alt="logo" />
      </a>
      <p
        class="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white"
      >
        Algo deu errado.
      </p>
      <p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
        Desculpe, não conseguimos encontrar essa página.
      </p>
      <a
        routerLink="/"
        class="inline-flex text-black bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4"
        >Voltar para a página inicial</a
      >
    </div>
  </div>
</section>
